export default __webpack_public_path__ + "static/media/red-brakes.4c768dc2.svg";